import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FileData } from '@uzurv/core';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TransitProgram, Vehicle, VehicleOwnershipType } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class VehicleService extends UzurvRestService {
  readonly resourceUrl = 'vehicles/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Find a vehicle by id
   *
   * @param vehicleId
   */
  findById(vehicleId: number): Observable<Vehicle> {
    return this.get<Vehicle>(`${this.resourceUrl}${vehicleId}`).pipe(map(result => Deserialize(result, Vehicle)));
  }

  /**
   * Get a vehicles image as FileData
   *
   * @param vehicleId
   */
  getVehicleImageForVehicle(vehicleId: number): Observable<FileData> {
    return this.get(`${this.resourceUrl}${vehicleId}/vehicleImage`).pipe(map(response => Deserialize(response, FileData)));
  }

  /**
   * List all vehicle ownership types.
   *
   */
  listAllVehicleOwnershipTypes(): Observable<Array<VehicleOwnershipType>> {
    return this.get(`${this.resourceUrl}vehicleOwnershipTypes/`, {
      pageNumber: 0,
      pageSize: 100
    }).pipe(map(response => Deserialize(response, VehicleOwnershipType)));
  }

  /**
   * Checks to see if a vehicle is eligible for any of the given transit programs
   *
   * @param vehicle
   * @param transitPrograms
   */
  isVehicleEligibleForAnyTransitProgram(vehicle: Vehicle, transitPrograms: Array<TransitProgram>): boolean {
    if (transitPrograms.length === 0) {
      return true;
    }

    for (const transitProgram of transitPrograms) {
      const cutoffYear: number = new Date().getFullYear() - transitProgram.maximumVehicleAgeInYears;
      if (+vehicle.automobile.year >= cutoffYear) {
        return true;
      }
    }
    return false;
  }

  protected getApiUrl(): string {
    return this.uzurvRestConfiguration.dotsApiUrl;
  }
}
